<template>
  <div>
    <svg
      width="205"
      height="138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M110.194 123.3c56.143-6.832 98.335-39.666 94.238-73.335C200.335 16.295 151.5-5.462 95.356 1.37 39.213 8.202-2.979 41.036 1.118 74.705c4.097 33.67 52.932 55.427 109.076 48.595z"
          fill="#F8F9FC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M193.397 69.279c-.555.732-1.766 2.34-1.21 3.069l1.395 1.83c.555.728.558 2.331.006 3.066l-1.407 1.87c-.553.736-.549 2.343.008 3.069l1.379 1.796c.559.728.56 2.343.002 3.075l-1.38 1.81c-.557.73-.556 2.342 0 3.072l1.376 1.804c.559.733.556 2.352-.005 3.078l-1.366 1.767c-.559.724-.564 2.335-.009 3.072l1.401 1.863c.552.735.55 2.338-.005 3.066l-1.4 1.836c-.554.727.655 2.331 1.207 3.065l.03.039c.766 1.018.4 3.375-.525 3.375h-85.783c-.926 0-1.291-2.36-.524-3.377l.016-.021c.554-.733 1.764-2.338 1.208-3.067l-1.393-1.828c-.556-.729-.557-2.336-.003-3.069l1.397-1.845c.555-.733.553-2.34-.002-3.069l-1.386-1.818c-.558-.73-.557-2.344.001-3.073l1.381-1.805c.557-.728.559-2.337.004-3.07l-1.38-1.824c-.559-.737-.552-2.359.012-3.08l1.402-1.793c.566-.725.569-2.357.005-3.089l-1.415-1.835c-.561-.728-.563-2.346-.003-3.078l1.377-1.803c.556-.728-.653-2.336-1.208-3.069l-.008-.01c-.768-1.016-.403-3.378.523-3.378h85.76c.926 0 1.291 2.364.522 3.379z"
          fill="#F3BEC5"
        />
        <path
          d="M188 68.4h-76a.5.5 0 00-.5.5v42a.5.5 0 00.5.5h76a.5.5 0 00.5-.5v-42a.5.5 0 00-.5-.5z"
          stroke="#F9FCFF"
          stroke-opacity=".2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M174.198 15.382c-.738.971-2.348 3.104-1.609 4.071l1.856 2.429c.737.965.741 3.091.007 4.065l-1.87 2.482c-.736.977-.731 3.108.01 4.07l1.833 2.383c.743.966.745 3.108.004 4.079l-1.835 2.402c-.74.969-.74 3.106 0 4.075l1.829 2.392c.743.973.74 3.12-.007 4.084l-1.815 2.344c-.744.96-.751 3.097-.013 4.075l1.863 2.471c.734.975.731 3.101-.007 4.067l-1.861 2.435c-.737.965.871 3.092 1.605 4.066l.039.052c1.019 1.351.532 4.476-.697 4.476H59.477c-1.23 0-1.716-3.13-.696-4.479l.021-.027c.736-.973 2.345-3.103 1.606-4.069L58.555 64.9c-.739-.967-.74-3.099-.003-4.07l1.857-2.449c.738-.971.736-3.103-.003-4.07L58.563 51.9c-.74-.97-.74-3.11.002-4.078l1.837-2.395c.74-.965.743-3.1.005-4.072l-1.835-2.419c-.743-.978-.735-3.13.015-4.086l1.864-2.378c.754-.962.757-3.127.007-4.098l-1.881-2.434c-.746-.965-.748-3.112-.005-4.083l1.832-2.392c.74-.965-.869-3.098-1.606-4.07l-.01-.014C56.5 9.9 65.269 10.9 66.5 10.9h107.952c4.048 0 .768 3.135-.254 4.481z"
          fill="url(#paint0_linear)"
        />
        <g style="mix-blend-mode: multiply">
          <path
            d="M65.5 16.9a2.5 2.5 0 012.5-2.5h97a2.5 2.5 0 012.5 2.5v53a2.5 2.5 0 01-2.5 2.5H68a2.5 2.5 0 01-2.5-2.5v-53z"
            stroke="#EAF1F7"
          />
        </g>
        <path
          d="M129.199 93.96c-.632 0-1.196-.143-1.692-.431a3.285 3.285 0 01-1.164-1.2 3.449 3.449 0 01-.42-1.704c0-.64.136-1.213.408-1.716a3.07 3.07 0 011.116-1.189c.472-.296 1.016-.444 1.632-.444 1 0 1.812.385 2.436 1.153.088.096.12.2.096.311a.475.475 0 01-.204.276.396.396 0 01-.3.072.506.506 0 01-.276-.18 2.233 2.233 0 00-1.752-.791c-.448 0-.844.108-1.188.323-.336.216-.6.513-.792.889a2.912 2.912 0 00-.276 1.296c0 .48.1.907.3 1.284.2.375.48.671.84.887.36.216.772.325 1.236.325.64 0 1.156-.172 1.548-.516a.53.53 0 01.3-.133c.104-.007.2.025.288.097a.444.444 0 01.156.3.31.31 0 01-.108.287c-.584.536-1.312.804-2.184.804zm7.709 0c-.64 0-1.212-.143-1.716-.431a3.137 3.137 0 01-1.188-1.188c-.288-.504-.432-1.076-.432-1.716 0-.648.144-1.225.432-1.728.288-.505.684-.9 1.188-1.189.504-.287 1.076-.431 1.716-.431.64 0 1.208.144 1.704.431.504.288.9.684 1.188 1.189.288.503.436 1.08.444 1.727 0 .64-.148 1.213-.444 1.717-.288.504-.684.9-1.188 1.188-.496.288-1.064.431-1.704.431zm0-.84c.464 0 .88-.108 1.248-.324.368-.216.656-.512.864-.888.208-.376.312-.803.312-1.284 0-.48-.104-.907-.312-1.283a2.282 2.282 0 00-.864-.9 2.419 2.419 0 00-1.248-.325c-.464 0-.88.109-1.248.325-.368.215-.66.516-.876.9a2.608 2.608 0 00-.312 1.284c0 .48.104.907.312 1.284.216.375.508.671.876.887.368.216.784.325 1.248.325zm8.489.852a3.265 3.265 0 01-1.524-.347 2.68 2.68 0 01-1.068-1.044c-.256-.457-.384-1.013-.384-1.669v-3.12a.44.44 0 01.132-.323.44.44 0 01.324-.132c.136 0 .248.043.336.132a.44.44 0 01.132.324v3.12c0 .736.204 1.284.612 1.644.408.36.92.54 1.536.54a2.38 2.38 0 001.056-.228c.32-.153.572-.36.756-.624.184-.264.276-.565.276-.9v-3.552c0-.137.04-.245.12-.325a.455.455 0 01.336-.132c.136 0 .248.044.336.133.088.08.132.188.132.324v5.64a.47.47 0 01-.132.347.48.48 0 01-.336.12.48.48 0 01-.336-.12.497.497 0 01-.12-.347v-.409a2.799 2.799 0 01-.96.697 2.966 2.966 0 01-1.224.251zm6.233 2.737a.47.47 0 01-.348-.133.454.454 0 01-.12-.335v-5.665a3.373 3.373 0 01.444-1.68c.296-.504.692-.9 1.188-1.188a3.35 3.35 0 011.692-.431c.64 0 1.212.147 1.716.444.504.287.9.683 1.188 1.188.296.503.444 1.075.444 1.715 0 .633-.144 1.2-.432 1.705-.28.504-.664.904-1.152 1.2a3.196 3.196 0 01-1.656.431 3.18 3.18 0 01-1.464-.335 2.965 2.965 0 01-1.044-.912v3.528a.431.431 0 01-.132.335.416.416 0 01-.324.133zm2.856-3.588c.464 0 .88-.108 1.248-.325.368-.216.656-.512.864-.888.216-.383.324-.811.324-1.284 0-.48-.108-.907-.324-1.283a2.304 2.304 0 00-.864-.888 2.352 2.352 0 00-1.248-.337 2.33 2.33 0 00-1.236.337 2.304 2.304 0 00-.864.888 2.608 2.608 0 00-.312 1.284c0 .472.104.9.312 1.284.208.375.496.671.864.887.368.216.78.325 1.236.325zm8.648.84c-.64 0-1.212-.144-1.716-.433a3.137 3.137 0 01-1.188-1.188c-.288-.504-.432-1.076-.432-1.716 0-.647.144-1.224.432-1.727.288-.505.684-.9 1.188-1.189.504-.287 1.076-.431 1.716-.431.64 0 1.208.144 1.704.431.504.288.9.684 1.188 1.189.288.503.436 1.08.444 1.727 0 .64-.148 1.213-.444 1.717-.288.504-.684.9-1.188 1.188-.496.288-1.064.431-1.704.431zm0-.84c.464 0 .88-.108 1.248-.325.368-.216.656-.512.864-.888.208-.376.312-.803.312-1.284 0-.48-.104-.907-.312-1.283a2.282 2.282 0 00-.864-.9 2.419 2.419 0 00-1.248-.325c-.464 0-.88.109-1.248.325-.368.215-.66.516-.876.9a2.608 2.608 0 00-.312 1.284c0 .48.104.907.312 1.284.216.375.508.671.876.887.368.216.784.325 1.248.325zm6.102.78a.497.497 0 01-.348-.12.48.48 0 01-.12-.337v-5.64c0-.144.04-.255.12-.335a.47.47 0 01.348-.132c.136 0 .244.043.324.132.088.08.132.192.132.336v.407c.256-.296.572-.528.948-.696a3.05 3.05 0 011.236-.252c.568 0 1.076.12 1.524.36.448.233.8.577 1.056 1.032.264.456.396 1.012.396 1.668v3.12a.44.44 0 01-.132.325.44.44 0 01-.324.131.455.455 0 01-.336-.132.44.44 0 01-.132-.323v-3.12c0-.745-.208-1.293-.624-1.645-.408-.36-.916-.54-1.524-.54-.392 0-.748.076-1.068.228a1.9 1.9 0 00-.744.625 1.536 1.536 0 00-.276.9v3.552a.455.455 0 01-.132.336.438.438 0 01-.324.12z"
          fill="#fff"
        />
        <path
          style="mix-blend-mode: multiply"
          opacity=".7"
          d="M119.096 114.901l54.904-39h-67.086a.586.586 0 00-.414 1l.982 1.309a3.679 3.679 0 01-.482 4.94l-.372.633a3.001 3.001 0 00.088 3.18l.668 1.005a4 4 0 01-.208 4.713l-.585.731a3 3 0 00.112 3.881l.573.636a3.503 3.503 0 01-.127 4.822 3.504 3.504 0 00-.325 4.581l1.176 1.569-2 3v3h13.096z"
          fill="url(#paint1_linear)"
          fill-opacity=".44"
        />
        <g style="mix-blend-mode: multiply">
          <path
            d="M68.5 17.9a.5.5 0 01.5-.5h95a.5.5 0 01.5.5v51a.5.5 0 01-.5.5H69a.5.5 0 01-.5-.5v-51z"
            stroke="#EAF1F7"
          />
        </g>
        <g opacity=".7">
          <mask
            id="a"
            maskUnits="userSpaceOnUse"
            x="90"
            y="27"
            width="8"
            height="2"
          >
            <path
              opacity=".7"
              d="M90 28.4a.5.5 0 00.5.5h7a.5.5 0 100-1h-7a.5.5 0 00-.5.5z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#a)">
            <path
              opacity=".7"
              d="M90.5 27.9h7v2h-7v-2zm7 1h-7v-2h7v2zm-7 0a.5.5 0 00.5-.5h-2a1.5 1.5 0 011.5-1.5v2zm6.5-.5a.5.5 0 00.5.5v-2a1.5 1.5 0 011.5 1.5h-2zm.5-.5a.5.5 0 00-.5.5h2a1.5 1.5 0 01-1.5 1.5v-2zm-7 2a1.5 1.5 0 01-1.5-1.5h2a.5.5 0 00-.5-.5v2z"
              fill="#F9FCFF"
            />
          </g>
        </g>
        <g opacity=".7">
          <mask
            id="b"
            maskUnits="userSpaceOnUse"
            x="135"
            y="27"
            width="8"
            height="2"
          >
            <path
              opacity=".7"
              d="M135 28.4a.5.5 0 00.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#b)">
            <path
              opacity=".7"
              d="M135.5 27.9h7v2h-7v-2zm7 1h-7v-2h7v2zm-7 0a.5.5 0 00.5-.5h-2a1.5 1.5 0 011.5-1.5v2zm6.5-.5a.5.5 0 00.5.5v-2a1.5 1.5 0 011.5 1.5h-2zm.5-.5a.5.5 0 00-.5.5h2a1.5 1.5 0 01-1.5 1.5v-2zm-7 2a1.5 1.5 0 01-1.5-1.5h2a.5.5 0 00-.5-.5v2z"
              fill="#F9FCFF"
            />
          </g>
        </g>
        <g opacity=".7">
          <mask
            id="c"
            maskUnits="userSpaceOnUse"
            x="87"
            y="60"
            width="56"
            height="2"
          >
            <path
              opacity=".7"
              d="M87 61.4a.5.5 0 00.5.5h55a.5.5 0 000-1h-55a.5.5 0 00-.5.5z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#c)">
            <path
              opacity=".7"
              d="M87.5 60.9h55v2h-55v-2zm55 1h-55v-2h55v2zm-55 0a.5.5 0 00.5-.5h-2a1.5 1.5 0 011.5-1.5v2zm54.5-.5a.5.5 0 00.5.5v-2a1.5 1.5 0 011.5 1.5h-2zm.5-.5a.5.5 0 00-.5.5h2a1.5 1.5 0 01-1.5 1.5v-2zm-55 2a1.5 1.5 0 01-1.5-1.5h2a.5.5 0 00-.5-.5v2z"
              fill="#F9FCFF"
            />
          </g>
        </g>
        <g opacity=".16">
          <mask
            id="d"
            maskUnits="userSpaceOnUse"
            x="137"
            y="79"
            width="26"
            height="2"
          >
            <path
              opacity=".16"
              d="M137 80.4a.5.5 0 00.5.5h25a.5.5 0 000-1h-25a.5.5 0 00-.5.5z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#d)">
            <path
              opacity=".16"
              d="M137.5 79.9h25v2h-25v-2zm25 1h-25v-2h25v2zm-25 0a.5.5 0 00.5-.5h-2a1.5 1.5 0 011.5-1.5v2zm24.5-.5a.5.5 0 00.5.5v-2a1.5 1.5 0 011.5 1.5h-2zm.5-.5a.5.5 0 00-.5.5h2a1.5 1.5 0 01-1.5 1.5v-2zm-25 2a1.5 1.5 0 01-1.5-1.5h2a.5.5 0 00-.5-.5v2z"
              fill="#F9FCFF"
            />
          </g>
        </g>
        <g opacity=".16">
          <mask
            id="e"
            maskUnits="userSpaceOnUse"
            x="137"
            y="99"
            width="26"
            height="2"
          >
            <path
              opacity=".16"
              d="M137 100.401a.5.5 0 00.5.5h25a.5.5 0 000-1h-25a.5.5 0 00-.5.5z"
              fill="#fff"
            />
          </mask>
          <g mask="url(#e)">
            <path
              opacity=".16"
              d="M137.5 99.9h25v2.001h-25v-2zm25 1.001h-25v-2h25v2zm-25 0a.5.5 0 00.5-.5h-2a1.5 1.5 0 011.5-1.5v2zm24.5-.5a.5.5 0 00.5.5v-2a1.5 1.5 0 011.5 1.5h-2zm.5-.5a.5.5 0 00-.5.5h2a1.5 1.5 0 01-1.5 1.5v-2zm-25 2a1.5 1.5 0 01-1.5-1.5h2a.5.5 0 00-.5-.5v2z"
              fill="#F9FCFF"
            />
          </g>
        </g>
        <path
          d="M102.68 27.111c.774 0 1.125.531 1.242.99l.648-.278c-.18-.684-.783-1.36-1.89-1.36-1.215 0-2.133.936-2.133 2.277 0 1.315.9 2.287 2.142 2.287 1.107 0 1.71-.703 1.917-1.341l-.63-.28c-.126.396-.468.973-1.287.973-.765 0-1.422-.604-1.422-1.639 0-1.043.657-1.628 1.413-1.628zm5.317-.648c-1.242 0-2.16.954-2.16 2.277 0 1.333.918 2.287 2.16 2.287s2.16-.954 2.16-2.287c0-1.322-.918-2.276-2.16-2.276zm0 .648c.774 0 1.44.585 1.44 1.63 0 1.053-.666 1.637-1.44 1.637-.774 0-1.44-.584-1.44-1.637 0-1.044.666-1.63 1.44-1.63zm6.631 3.204v.037c0 .215.018.45.045.549h.693a5.705 5.705 0 01-.054-.81v-3.502h-.72v2.602c0 .684-.387 1.188-1.098 1.188-.765 0-1.062-.568-1.062-1.198V26.59h-.72v2.709c0 .954.576 1.727 1.62 1.727.567 0 1.089-.27 1.296-.71zm3.307 2.296v-2.376c.225.405.72.791 1.458.791 1.242 0 1.98-.998 1.98-2.285 0-1.288-.693-2.277-1.962-2.277-.765 0-1.269.405-1.494.846v-.72h-.702v6.02h.72zm1.35-2.232c-.828 0-1.368-.684-1.368-1.639 0-.953.531-1.628 1.368-1.628.837 0 1.368.675 1.368 1.629s-.54 1.637-1.368 1.637zm5.566-3.916c-1.242 0-2.16.954-2.16 2.277 0 1.333.918 2.287 2.16 2.287s2.16-.954 2.16-2.287c0-1.322-.918-2.276-2.16-2.276zm0 .648c.774 0 1.44.585 1.44 1.63 0 1.053-.666 1.637-1.44 1.637-.774 0-1.44-.584-1.44-1.637 0-1.044.666-1.63 1.44-1.63zm4.49 1.252c0-.675.387-1.252 1.08-1.252.783 0 1.071.505 1.071 1.134V30.9h.72v-2.762c0-.937-.504-1.675-1.539-1.675-.567 0-1.071.27-1.35.774v-.647h-.702v4.31h.72v-2.537z"
          fill="#fff"
        />
        <path
          style="mix-blend-mode: multiply"
          d="M112 75.9l3-21-2 .5-10.5 20.5h9.5z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M93.163 80.506l14.221-19.546c1.731-2.38 3.499-4.797 5.866-6.552.417-.31 1.02-.594 1.418-.26.368.308.251.89.096 1.341-3.469 10.114-9.785 19.022-16.73 27.171-2.12 2.487-4.789 5.13-8.064 4.93-.543-.033-1.217-.306-1.195-.846.304-2.58 3.696-5.89 5.39-7.685"
          fill="#FF8995"
        />
        <path
          d="M29.914 125.544a185.495 185.495 0 0027.287-4.352c3.145-.746 6.464-1.687 8.63-4.085-.295-.605-2.65-.046-3.331 0-11.645.792-28 1.794-33.5 2.794-.34.022-.443.761-.716.967a1.396 1.396 0 00-.372.918c-.108 1.618-.912 4.115 2.004 3.758"
          fill="#FF6575"
        />
        <path
          d="M28 121.4c1.843.394 2-2 6.5-2 2.051-1 7.442-12.538 11.148-19.043-3.086.747-7.158 2.546-9.097 0a4.92 4.92 0 00-1.606 2.395"
          fill="#A4A5DF"
        />
        <path
          d="M47.203 115.127c.518 1.242.806 2.567.848 3.912-.054 1.761-1.431 4.036-2.404 5.485-1.985 2.959-3.129 5.823-3.526 9.042-.2 1.62.828 3.152 2.424 3.498 7.958 1.728 13.454-4.033 19.463-5.985 2.784-.905 4.592-2.382 3.858-5.216-.558-2.155-1.222-4.456-1.482-5.482-1.766-6.951 4.492-13.149 4.143-20.313a2.042 2.042 0 00-.271-1.075c-.735-1.067-2.497-.18-3.676-.717-1.188-.543-1.237-2.185-1.104-3.484.395-3.841.06-7.771.522-11.606-1.568-.677-3.334 3.286-4.119 4.336a32.476 32.476 0 00-3.866 6.71 4.948 4.948 0 00-.534 2.262c.088 1.181.943 2.162 1.862 2.91a12.332 12.332 0 007.57 2.741c1.11.013 2.366-.21 2.985-1.131.764-1.136.245-2.893 1.225-3.85.292-.253.627-.453.988-.589l17.9-7.974a18.368 18.368 0 013.231-1.203c1.758-.472-.216-4.576 0-7.341-5.444 2.264-9.895 2.971-15.728 3.835a21.565 21.565 0 01-6.745.177c-2.954-.502-5.838-1.222-8.838-1.373a2.257 2.257 0 00-1.21.169c-.415.228-5.108-.22-5.302.212-2.062 4.595-2.782 3.73-7.236 6.081-1.406.742 1.146 8.539-.372 9.01-1.517.472-3.054 1.196-3.94 2.515-.885 1.319-.371.718.45 4.283"
          fill="#A4A5DF"
        />
        <path
          style="mix-blend-mode: multiply"
          d="M45.998 110.401c3.6-.4 13-16.5 14.5-19.5l-11.5 2-5 10.5 2 7z"
          fill="url(#paint3_linear)"
          fill-opacity=".5"
        />
        <path
          style="mix-blend-mode: multiply"
          opacity=".6"
          d="M32.498 109.901c3.6-.4 9.167-4.5 11.5-6.5l-8.5-2-3 8.5z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M61.102 79.844c-.384 1.807.164 5.806-2.396 4.853-.855-.318-1.772-.425-2.175-1.285a4.752 4.752 0 01-.192-2.542c.006-.774.275-1.52.757-2.105.7-.667 1.778-.54 2.706-.358.398.046.78.189 1.117.416.34.242.483.695.347 1.103"
          fill="#D53A79"
        />
        <path
          d="M64.888 60.196a24.774 24.774 0 011.83 4.409 20.05 20.05 0 01.564 5.073c.116 2.067-.08 5.775-.784 7.722-1.212 2.886-4.001 3.25-7.116 3.598a7.774 7.774 0 01-7.55-4.207 13.337 13.337 0 01-.997-4.877c-.19-2.84-.24-5.741.54-8.48.779-2.738 2.495-5.326 5.06-6.572 2.564-1.246 6.005-.837 7.81 1.368"
          fill="url(#paint5_linear)"
        />
        <path
          d="M53.23 53.373c-3.165.678-6.453.633-9.61 1.346a8.827 8.827 0 00-4.054 1.86 7.698 7.698 0 00-2.246 5.026 11.888 11.888 0 001.324 6.648 13.06 13.06 0 001.066 1.676c2.138 2.87 1.927 7.185-.372 9.928a19.948 19.948 0 00-3.563 6.289c-.383 1.124-.658 2.394-.163 3.474 3.122 6.804-1.818-.896-1.943 7.749-.042 2.873 2.164 5.516 4.906 6.346 2.742.831 5.825.005 8.07-1.78 2.206-1.867 5.897-6.222 6.585-9.035 2.159 1.117-3.232 5 4.627 1.411a6.631 6.631 0 002.831-6.17 6.62 6.62 0 00-4.071-5.426c1.62-.165 2.478-2.219 2.014-3.785-.463-1.567-1.788-2.7-3.073-3.705a1.274 1.274 0 01-.564-.73c-.069-.445.33-.806.666-1.106a7.727 7.727 0 00-1.052-12.305c2.674.275 5.373.148 8.01-.378a3.08 3.08 0 011.38-.074c1.352.358 1.526 2.3 2.648 3.134.84-3.827 1.107-8.101-.586-11.75-3.591-7.743-9.863.722-12.83 1.357z"
          fill="#282A69"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="58"
          y1="15.4"
          x2="175"
          y2="75.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A3CDE1" />
          <stop
            offset="1"
            stop-color="#B3EDF1"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="139.5"
          y1="75.9"
          x2="108"
          y2="113.901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8742A0" />
          <stop
            offset="1"
            stop-color="#8742A0"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="108.75"
          y1="55.401"
          x2="108.75"
          y2="75.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3D6E3" />
          <stop
            offset="1"
            stop-color="#C4C4C4"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="52.998"
          y1="94.4"
          x2="56.498"
          y2="105.901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4C49C5" />
          <stop
            offset="1"
            stop-color="#4C49C5"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="38.248"
          y1="101.401"
          x2="38.248"
          y2="109.901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4C49C5" />
          <stop
            offset="1"
            stop-color="#4C49C5"
            stop-opacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="59.015"
          y1="56.166"
          x2="59.015"
          y2="81.023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8995" />
          <stop
            offset="1"
            stop-color="#FF6575"
          />
        </linearGradient>
        <clipPath id="clip0">
          <path
            fill="#fff"
            d="M0 0h205v138H0z"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
